import { render, staticRenderFns } from "./GroupMassageChatIcon.vue?vue&type=template&id=305f3def"
import script from "./GroupMassageChatIcon.vue?vue&type=script&lang=js"
export * from "./GroupMassageChatIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports